export default "__VITE_ASSET__0p6P6U24__"